<button class="button-toggle"
  [class.button-toggle--selected]="isSelected"
  (click)="isSelected=!isSelected"
  [fmTooltip]="tooltip">
  <mat-icon class="button-toggle__icon mat-icon-size-xs"
    *ngIf="iconName"
    [svgIcon]="iconName"></mat-icon>
  <ng-content></ng-content>
</button>